<template>
  <WsMain>
    <WsCrud
      :modelName="$store.state.model[modelName].modelName"
      label="我的請假"
      :fields="$store.state.model[modelName].fields"
      :liveSearching="true"
      :showFields="showFields"
      :fetchQuery="_fetchQuery"
      :inRowBtnUpdate="false"
      :inRowBtnDelete="false"
      :updatable="false"
      :createHideFields="createHideFields"
      :createDefaultValues="_createDefaultValues"
      :infiniteScroll="true"
    ></WsCrud>
  </WsMain>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "我的請假",
    };
  },
  data: () => ({
    createHideFields: ["status", "wasa"],
    modelName: "leave_day",
    showFields: ["id", "start_date", "days", "status"],
  }),

  computed: {
    _createDefaultValues() {
      return {
        wasa: this._currentUser.id,
      };
    },
    _fetchQuery() {
      return {
        wasa: this._currentUser.id,
      };
    },
    _currentUser() {
      return this.$store.state.auth.currentUser;
    },
  },
};
</script>